"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalData = void 0;
const _ = __importStar(require("lodash"));
const filters_1 = require("./filters");
const helpers_1 = require("./helpers");
const slickgrid_1 = require("slickgrid");
class LocalData {
    pluginName = 'LocalData';
    eventHandler;
    dataview;
    grid;
    $filter;
    groupItemMetadataProvider;
    options;
    items;
    externalRowAdapter;
    onDataLoading;
    onDataLoaded;
    onDataLoadFailed;
    onRowCountChanged;
    onRowsChanged;
    containsFilter;
    get data() {
        return this.dataview;
    }
    replaceDataSource(ds) {
        if (_.isArray(ds)) {
            this.setItems(_.cloneDeep(ds));
        }
        else if (_.isFunction(ds)) {
            this.items = ds;
            this.reload();
        }
    }
    constructor(options) {
        this.eventHandler = new slickgrid_1.SlickEventHandler();
        this.onDataLoading = new slickgrid_1.SlickEvent();
        this.onDataLoaded = new slickgrid_1.SlickEvent();
        this.onDataLoadFailed = new slickgrid_1.SlickEvent();
        this.onRowCountChanged = new slickgrid_1.SlickEvent();
        this.onRowsChanged = new slickgrid_1.SlickEvent();
        this.options = options;
        this.items = options.items;
        if (_.isFunction(options.rowAdapter)) {
            this.externalRowAdapter = options.rowAdapter;
        }
        const dvOptions = {};
        if (options.groupBy) {
            this.groupItemMetadataProvider = dvOptions.groupItemMetadataProvider = new slickgrid_1.SlickGroupItemMetadataProvider();
        }
        this.dataview = new slickgrid_1.SlickDataView(dvOptions);
        this.dataview.getItemMetadata = this.getItemMetadata.bind(this);
    }
    init(grid) {
        this.grid = grid;
        this.$filter = new filters_1.DataFilter(grid);
        this.eventHandler
            .subscribe(this.dataview.onRowsChanged, this.onDataViewRowsChanged.bind(this))
            .subscribe(this.dataview.onRowCountChanged, this.onDataViewRowCountChanged.bind(this))
            .subscribe(grid.onSort, this.onSort.bind(this));
        this.containsFilter = (0, helpers_1.containsFilterFn)(grid);
        const unsubscribe = () => grid.onViewportChanged.unsubscribe(callback);
        const callback = this.onViewportChangedFirst.bind(this, unsubscribe);
        grid.onViewportChanged.subscribe(callback);
        if (this.groupItemMetadataProvider) {
            grid.registerPlugin(this.groupItemMetadataProvider);
            grid.setSelectionModel(new slickgrid_1.SlickCellSelectionModel());
            grid.setOptions({ enableCellNavigation: true });
        }
        this.dataview.syncGridSelection(grid, true);
    }
    destroy() {
        this.eventHandler.unsubscribeAll();
    }
    getItemMetadata(index) {
        const item = this.dataview.rows[index];
        if (item === undefined) {
            return null;
        }
        if (item.__group) {
            return this.dataview._options.groupItemMetadataProvider.getGroupRowMetadata(item);
        }
        if (item.__groupTotals) {
            return this.dataview._options.groupItemMetadataProvider.getTotalsRowMetadata(item);
        }
        const result = _.get(item, '$__itemMetadata__', null);
        if (result) {
            return result;
        }
        return null;
    }
    getItems(visibleOnly = false) {
        return visibleOnly
            ? _.map(_.range(this.dataview.getLength()), i => this.dataview.getItem(i))
            : this.dataview.getItems();
    }
    setItems(items) {
        if (!items) {
            return;
        }
        _.each(items, item => this.rowAdapter(item));
        this.dataview.beginUpdate();
        this.dataview.setItems(items);
        this.dataview.setFilter(this.$filter.callback);
        this.dataview.endUpdate();
        this.applySorters();
    }
    addItem(item) {
        this.dataview.beginUpdate();
        this.dataview.addItem(this.rowAdapter(item));
        this.dataview.setFilter(this.$filter.callback);
        this.dataview.endUpdate();
        this.applySorters();
    }
    addItems(items) {
        this.dataview.beginUpdate();
        for (const item of items) {
            this.dataview.addItem(this.rowAdapter(item));
        }
        this.dataview.setFilter(this.$filter.callback);
        this.dataview.endUpdate();
        this.applySorters();
    }
    updateItem(id, item) {
        this.rowAdapter(item);
        this.dataview.beginUpdate();
        this.dataview.updateItem(id, item);
        this.dataview.endUpdate();
        this.applySorters();
    }
    removeItem(id) {
        this.dataview.beginUpdate();
        this.dataview.deleteItem(id);
        this.dataview.setFilter(this.$filter.callback);
        this.dataview.endUpdate();
        this.applySorters();
    }
    removeItems(ids) {
        this.dataview.beginUpdate();
        for (const id of ids) {
            this.dataview.deleteItem(id);
        }
        this.dataview.setFilter(this.$filter.callback);
        this.dataview.endUpdate();
        this.applySorters();
    }
    filter(args) {
        this.$filter.setFilters(args);
        this.dataview.refresh();
    }
    groupBy(groupingInfo) {
        this.dataview.beginUpdate();
        this.dataview.setGrouping(groupingInfo);
        this.dataview.endUpdate();
    }
    expandAllGroups() {
        this.dataview.expandAllGroups();
    }
    collapseAllGroups() {
        this.dataview.collapseAllGroups();
    }
    applyFilters() {
        this.dataview.refresh();
    }
    async reload() {
        if (_.isFunction(this.items)) {
            await this.loadItems();
        }
    }
    async loadItems() {
        this.onDataLoading.notify();
        let items;
        if (_.isFunction(this.items)) {
            try {
                items = await this.items();
            }
            catch (error) {
                this.onDataLoadFailed.notify({ error });
                return;
            }
        }
        else {
            items = this.items;
        }
        this.setItems(items);
        this.onDataLoaded.notify();
        return items;
    }
    onDataViewRowsChanged(e, args) {
        this.grid.invalidateRows(args.rows);
        this.grid.invalidate();
        this.grid.render();
        this.onRowsChanged.notify({
            total: this.dataview.getItems().length,
            visible: args.rows.length
        });
    }
    onDataViewRowCountChanged(e, args) {
        this.grid.updateRowCount();
        this.grid.render();
        this.onRowCountChanged.notify({
            total: this.dataview.getItems().length,
            visible: args.current
        });
    }
    onSort(e, args) {
        const sorters = args.multiColumnSort
            ? args.sortCols
            : [{ sortAsc: args.sortAsc, sortCol: args.sortCol }];
        (0, helpers_1.sortDataView)(this.grid, this.dataview, sorters);
    }
    onViewportChangedFirst(unsubscribe, e, args) {
        unsubscribe();
        if (this.options.groupBy) {
            this.groupBy(this.options.groupBy);
        }
        if (_.isArray(this.options.items)) {
            this.onDataLoading.notify();
            const result = this.setItems(this.options.items);
            this.onDataLoaded.notify();
            return result;
        }
        if (_.isFunction(this.options.items)) {
            return this.loadItems();
        }
    }
    rowAdapter(data) {
        return this.externalRowAdapter ? this.externalRowAdapter(data) : data;
    }
    applySorters() {
        const sortCols = (0, helpers_1.getSortColumns)(this.grid);
        if (sortCols) {
            (0, helpers_1.sortDataView)(this.grid, this.dataview, sortCols);
        }
    }
}
exports.LocalData = LocalData;
const aggregateRegex = /^(avg|min|max|sum)\(([\w$]+)\)$/g;
function createAggregator(config) {
    if (_.isString(config)) {
        let m;
        while ((m = aggregateRegex.exec(config)) !== null) {
            if (m.index === aggregateRegex.lastIndex) {
                aggregateRegex.lastIndex++;
            }
            if (m.length === 3) {
                return new Slick.Data.Aggregators[_.startCase(m[1])](m[2]);
            }
        }
        throw new TypeError(`createAggregator failed. config: ${config} [slickg.dataview]`);
    }
    return config;
}
//# sourceMappingURL=LocalData.js.map